import { render, staticRenderFns } from "./right-item.vue?vue&type=template&id=b544b33c&scoped=true&"
import script from "./right-item.vue?vue&type=script&lang=js&"
export * from "./right-item.vue?vue&type=script&lang=js&"
import style0 from "./right-item.vue?vue&type=style&index=0&id=b544b33c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544b33c",
  null
  
)

export default component.exports